export default __webpack_public_path__ + "images/3L.41a2d63.png";